// Cookieless page analytics via Umami. Off unless the server injected
// window.__MNANDI_ANALYTICS__ because UMAMI_WEBSITE_ID is set. Optional
// UMAMI_SCRIPT_SRC overrides the script URL (default https://cloud.umami.is/script.js,
// https only). Nothing here reads a name, email, or user id, and page views
// send the path only (query strings can carry password-reset tokens).
// Events: signup-started, calculator-used, trial-started.

const DEFAULT_SRC = "https://cloud.umami.is/script.js";

let ready = false;
const pending = [];

export function analyticsConfig(injected) {
  const source = injected === undefined && typeof window !== "undefined" ? window.__MNANDI_ANALYTICS__ : injected;
  if (!source || typeof source !== "object") return null;
  const websiteId = String(source.websiteId || "").trim();
  if (!websiteId) return null;
  const src = String(source.src || "").trim() || DEFAULT_SRC;
  if (!src.startsWith("https://")) return null;
  return { websiteId, src };
}

function callTrack(fn) {
  if (!analyticsConfig()) return;
  if (ready && typeof window !== "undefined" && window.umami && typeof window.umami.track === "function") {
    fn();
    return;
  }
  pending.push(fn);
}

function flush() {
  ready = true;
  const queued = pending.splice(0);
  queued.forEach((fn) => fn());
}

export function initAnalytics() {
  const config = analyticsConfig();
  if (!config || typeof document === "undefined") return;
  if (document.querySelector("script[data-mnandi-analytics]")) return;
  const script = document.createElement("script");
  script.defer = true;
  script.dataset.websiteId = config.websiteId;
  script.dataset.autoPageview = "false";
  script.dataset.mnandiAnalytics = "umami";
  script.src = config.src;
  script.onload = flush;
  script.onerror = () => {
    pending.splice(0);
  };
  document.head.appendChild(script);
}

export function trackPageview(pathname) {
  const url = pathname || "/";
  const title = typeof document !== "undefined" ? document.title : "";
  callTrack(() => {
    window.umami.track((props) => ({ ...props, url, title }));
  });
}

export function trackEvent(name, data) {
  callTrack(() => {
    if (data) window.umami.track(name, data);
    else window.umami.track(name);
  });
}
